import FaqList from '@/views/faq/FaqList'

export default [
    {
        path: '/faq',
        name: 'faq',
        component: FaqList,
        meta: {
            auth: true,
            logging: true, 
            pageName: 'FAQ' 
        }
    }

]